import * as Yup from 'yup';
import agent from 'src/api/agent';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFSelect, RHFTextField } from 'src/components/hook-form';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  MenuItem,
  Stack,
} from '@mui/material';

type FormValues = {
  reason: string;
  reasonNote: string;
};

const RejectDialog = ({ rejectCounty, isOpen, handlerReject, handlerIsOpenConfirmDialog }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [openDialog, setOpenDialog] = useState(isOpen);
  const [reasonItems, setReasonItems] = useState<any>([]);

  const reasonRejectCatalog = 'disposition_reason';

  const fetchCatalogReason = async () => {
    const catalog = await agent.Catalog.getCatalogByCode(reasonRejectCatalog);
    setReasonItems(catalog);
  };

  useEffect(() => {
    if (rejectCounty) {
      setValue('reason', 'Live out of County');
      setValue('reasonNote', 'The address is out of county');
    }
  }, [rejectCounty]);

  useEffect(() => {
    setOpenDialog(isOpen);
    fetchCatalogReason();
  }, [isOpen]);

  const handleCloseForm = () => {
    reset();
    setOpenDialog(false);
    handlerIsOpenConfirmDialog(false);
  };

  const defaultValues = {
    reason: '',
    reasonNote: '',
  };

  const EventSchema = Yup.object().shape({
    reason: Yup.string().max(255).required('Reason is required'),
    reasonNote: Yup.string().required('Reason Note is required').max(5000),
  });

  const methods = useForm<FormValues>({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const { reset, handleSubmit, setValue } = methods;

  const onSubmit = async (data: FormValues) => {
    try {
      handlerReject(data);
      handleCloseForm();
      enqueueSnackbar('Rejected successfully!');
    } catch (error) {
      handleCloseForm();
      enqueueSnackbar('An error was occurred', { variant: 'error', autoHideDuration: 6000 });
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseForm}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="confirm-dialog-title">Reason For Reject</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Card sx={{ m: 2 }}>
          <Grid container>
            <Grid item xs={12}>
              <Stack spacing={2} sx={{ p: 2 }}>
                <RHFSelect name="reason" label="Reason">
                  <MenuItem disabled/>
                  {reasonItems?.map((option) => (
                    <MenuItem key={option.id} value={option.valueDisplayName}>
                      {option?.valueDisplayName}
                    </MenuItem>
                  ))}
                </RHFSelect>
              </Stack>
              <Stack spacing={2} sx={{ p: 2 }}>
                <RHFTextField name="reasonNote" label="Reason Note" multiline rows={4} />
              </Stack>
            </Grid>
          </Grid>
          <Stack spacing={2} alignItems="center">
            <DialogActions>
              <Button onClick={handleCloseForm} variant="contained" color="info">
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="info">
                Submit
              </Button>
            </DialogActions>
          </Stack>
        </Card>
      </FormProvider>
    </Dialog>
  );
};

export default RejectDialog;
